import _Object$create from "../../core-js/object/create";
export default function _inheritsLoose(subClass, superClass) {
  subClass.prototype = _Object$create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/helpers/esm/inheritsLoose.js
// module id = 5
// module chunks = 0